var map = {
	"./de/btn-back.png": "DajH",
	"./en/btn-back.png": "x2nM",
	"./es/btn-back.png": "FrNB",
	"./fr/btn-back.png": "lIFJ",
	"./ja/btn-back.png": "V/59",
	"./ko/btn-back.png": "+wm/",
	"./pt/btn-back.png": "IgaV",
	"./ru/btn-back.png": "kyKa",
	"./th/btn-back.png": "aqS0",
	"./zh-Hant/btn-back.png": "QWRY"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2AOk";